import { observable, makeObservable } from 'mobx';
import {DomainObject} from 'shared/store';

class TaxFormTemplate extends DomainObject {
  id;
  templateType;
  locale;
  year;
  fileName;
  annotations = [];

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      templateType: observable,
      locale: observable,
      year: observable,
      fileName: observable,
      annotations: observable
    });

    this.merge(other);
  }
}

export default TaxFormTemplate;
